import { gridSize, gridSizeMdLg4, useTableFilter, useTableServerSideFiltering } from "@/shared"
import { CustomTextFieldNoForm, GeneralTable } from "@/shared/components/ui"
import useTableColumnsRegistroFacturas from "../../hook/useTableColumnsRegistroFacturas"
import { Button, Grid, } from "@mui/material"
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useState } from "react"
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs"
import { useFetchFacturaCompraGastoCombinado } from "@/shared/actions/erp/factura_compra_gasto_combinado/factura_compra_gasto_combinado.action"
import { FacturaOrdenCompraGasto } from "@/shared/interfaces/erp/factura_compra_gasto/factura-compra-gasto.interface"

export default function TableRegistroFacturas() {
  //const navigate = useNavigate()
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [selectedFactura, setSelectedFactura] = useState<FacturaOrdenCompraGasto | null>(null)
  //
  const {
    columns
  } = useTableColumnsRegistroFacturas()
  //
  const {
    pagination,
    setPagination,
    searchTerm,

  } = useTableFilter()

  const {
    pageIndex,
    pageSize
  } = pagination

  const {
    columnFilters,
    setColumnFilters,
    filterObject
  } = useTableServerSideFiltering()


  const {
    data: dataFacturaCompraGastoCombinado,
    isLoading: isLoadingdataFacturaCompraGastoCombinado,
    isRefetching
  } = useFetchFacturaCompraGastoCombinado({
    page: pageIndex + 1,
    page_size: pageSize,
    codigo: searchTerm,
    ...filterObject,
    filterByState: false

  })

  const handleActions = (e: FacturaOrdenCompraGasto) => {
    console.log(e)

  }


  return (
    <>
      <GeneralTable
        columns={columns}
        data={dataFacturaCompraGastoCombinado?.data.data || []}
        isLoading={isLoadingdataFacturaCompraGastoCombinado}
        isRefetching={isRefetching}
        //
        enableGlobalFilter={false}
        //
        pagination={pagination}
        onPaging={setPagination}
        rowCount={dataFacturaCompraGastoCombinado?.data.count}
        //
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableManualFiltering={true}
        enableSorting={false}
        //crud
        canEdit={false}
        enableColumnActions={true}
        positionActionsColumn="first"
        showCustomActionBtnSpace={true}
        customActionBtnSpace={(value: FacturaOrdenCompraGasto) => {
          return (
            <>
              <Button
                size="medium"
                startIcon={<VisibilityIcon />}
                onClick={() => {
                  handleActions(value)
                  setSelectedFactura(value)
                  setIsOpenModal(true)
                }}
              >
                {"Ver"}
              </Button>

            </>
          )
        }}
      />
      <ScrollableDialogProps
        title="DETALLES - FACTURAS"
        open={isOpenModal}
        onCloseIcon={() => setIsOpenModal(false)}
        minWidth="60%"
        contentNode={
          <>
            <Grid container spacing={2} >
              <Grid item {...gridSize} container spacing={3}>
                <CustomTextFieldNoForm
                  label="Bodega"
                  value={selectedFactura?.bodega_data?.nombre || "N/A"}
                  size={gridSizeMdLg4}
                  disabled={true}
                />
                <CustomTextFieldNoForm
                  label="Ubicacion"
                  value={selectedFactura?.ubicacion_data?.nombre || "N/A"}
                  size={gridSizeMdLg4}
                  disabled={true}
                />

                <CustomTextFieldNoForm
                  label="Proveedor"
                  value={selectedFactura?.proveedor_data?.razon_social || "N/A"}
                  size={gridSizeMdLg4}
                  disabled={true}
                />
                <CustomTextFieldNoForm
                  label="Tipo comprobante"
                  value={selectedFactura?.tipo_comprobante_data?.nombre || "N/A"}
                  size={gridSizeMdLg4}
                  disabled={true}
                />
                <CustomTextFieldNoForm
                  label="Forma Pago"
                  value={selectedFactura?.forma_pago_data?.nombre || "N/A"}
                  size={gridSizeMdLg4}
                  disabled={true}
                />
                <CustomTextFieldNoForm
                  label="Numero Autorización"
                  value={selectedFactura?.factura_data?.info_adicional?.find(item => item.nombre === "numero_autorizacion")?.valor || "N/A"}
                  size={gridSizeMdLg4}
                  disabled={true}
                />
                <CustomTextFieldNoForm
                  label="Concepto"
                  value={selectedFactura?.factura_data?.info_adicional?.find(item => item.nombre === "concepto")?.valor || "N/A"}
                  size={gridSizeMdLg4}
                  disabled={true}
                />
                <CustomTextFieldNoForm
                  label="Fecha Emisión de Comprobante "
                  value={selectedFactura?.fecha_emision}
                  size={gridSizeMdLg4}
                  disabled={true}
                />
                <CustomTextFieldNoForm
                  label="Fecha Vencimiento de Documento "
                  value={selectedFactura?.fecha_vencimiento}
                  size={gridSizeMdLg4}
                  disabled={true}
                />


              </Grid>


            </Grid>

          </>
        }
      />
    </>
  )
}